import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

interface TeamMember {
  imageUrl: string;
  name: string;
  jobTitle: string;
}
@Component({
  selector: 'app-about',
  standalone: true,
  imports: [NgFor, TranslatePipe],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent {
  heroColors: Array<string> = [
    '#C3C3C3',
    '#BDB3A6',
    '#A7A39E',
    '#E0DFDC',
    '#EEE1D2',
    '#B9B0A3',
  ];
  heroImage: string = 'assets/images/about-us-img.png';
  defaultAvatar: string = 'assets/images/default-avatar.png';
  teamMembers: Array<TeamMember> = [
    {
      imageUrl: 'assets/images/hps_team/EmmanuelAkaa.jpg',
      name: 'Emmanuel Akaachukwu',
      jobTitle: 'about-us-page.jobTitles.leadEngineer',
    },
    {
      imageUrl: '',
      name: 'Ogomegbunam Chimeudeonwo',
      jobTitle: 'about-us-page.jobTitles.cto',
    },
    {
      imageUrl: 'assets/images/hps_team/ChrisNwasiwe.jpg',
      name: 'Chris Nwasiwe',
      jobTitle: 'about-us-page.jobTitles.productDesigner',
    },
    {
      imageUrl: '',
      name: 'Eberechukwu Nwaobiora',
      jobTitle: 'about-us-page.jobTitles.fullStackEngineer',
    },
    {
      imageUrl: 'assets/images/hps_team/Fatima_Jimoh.png',
      name: 'Fatima Jimoh',
      jobTitle: 'about-us-page.jobTitles.frontendEngineer',
    },
    {
      imageUrl: 'assets/images/hps_team/chijioke_stephen_chimeudeonwo.jpg',
      name: 'Stephen Chimeudeonwo',
      jobTitle: 'about-us-page.jobTitles.qa',
    },
    {
      imageUrl: 'assets/images/hps_team/ChukwuebukaAnunihu.jpg',
      name: 'Chukwuebuka Aninuhu',
      jobTitle: 'about-us-page.jobTitles.frontendEngineer',
    },
    {
      imageUrl: 'assets/images/hps_team/Chuks.png',
      name: 'Chukwuma Nnamani',
      jobTitle: 'about-us-page.jobTitles.productOwner',
    },
    {
      imageUrl: 'assets/images/hps_team/Chinwendu.jpg',
      name: 'Chinwendu Ibeachunam',
      jobTitle: 'about-us-page.jobTitles.accManager',
    },
    {
      imageUrl: '',
      name: 'Chinedu Eneh',
      jobTitle: 'about-us-page.jobTitles.devops',
    },
  ];
}
